import axios from "axios";
import { LocalStorageHelpers } from "../helpers/localstorage.helpers";
import { EnvVariables } from "../../enums/env.variables.enums";

// axios.defaults.withCredentials = true;

const axiosInstance = axios.create({
  baseURL: `${EnvVariables.apiEndpoint}/api`,
  // baseURL: "http://localhost:5000/api/",
  // baseURL: "http://192.168.1.7:5001/api",
  // baseURL: "http://192.168.1.5:5000/api",
  // baseURL: "http://82.180.131.48:5000/api",
  // baseURL: "https://dev.api.brandbards.com.au/api",
});

axiosInstance.interceptors.response.use((res) => {
  const authTokens = LocalStorageHelpers.getAuthTokens();

  let accessToken = authTokens.access_token;
  let refreshToken = authTokens.refresh_token;
  let temporaryToken = authTokens.temporary_access_token;

  const data = res.data.data;

  if (data) {
    let userData = null;
    let userRole = "";

    if (data?.user_data) {
      userData = data?.user_data;
      LocalStorageHelpers?.setUserData({
        data: userData,
      });
    }
  }

  if (data?.temporary_access_token)
    temporaryToken = data.temporary_access_token;
  if (data?.access_token) accessToken = data.access_token;
  if (data?.refresh_token) refreshToken = data.refresh_token;

  LocalStorageHelpers.setAuthTokens({
    access_token: accessToken,
    refresh_token: refreshToken,
    temporary_access_token: temporaryToken,
  });

  return res;
});

axiosInstance.interceptors.request.use((config) => {
  let authToken = "";

  const authTokens = LocalStorageHelpers.getAuthTokens();

  if (authTokens.temporary_access_token)
    authToken = authTokens.temporary_access_token;
  if (authTokens.access_token) authToken = authTokens.access_token;

  if (authToken) {
    config.headers["Authorization"] = `Bearer ${authToken || ""}`;
  }
  return config;
});

export default axiosInstance;
